<pr-modal-confirm
  #duplicateFundsOriginModal
  [title]="'Voulez-vous dupliquer les données pour toutes les SCPI ?'"
  [comment]="
    'Voulez-vous dupliquer l\'ensemble des données d\'origine des fonds pour toutes les SCPI ?'
  "
  [labelConfirm]="'Dupliquer'"
  [optionnalLabel]="'Saisir manuellement'"
  (onConfirm)="onConfirmDuplicateFundsOrigin()"
  (onConfirmOptionnal)="onCancelDuplicateFundsOrigin()"
  [showCancel]="false"
  display="neutral"
>
</pr-modal-confirm>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        <mat-step
          [formGroup]="scpi"
          [stepControl]="scpis?.get([i])"
          completed="false"
        >
          <ng-template matStepLabel
            >{{ scpi.get('productName').value }} ({{
              scpi?.get('parameters').get('scpiInvestmentPrice')?.value
            }}€)</ng-template
          >
          <funds-initial-scpi [derrors]="derrors"></funds-initial-scpi>
        </mat-step>
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
